/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { FormattedMessage } from 'react-intl';
import poutine from '../../../img/cards/poutine.png';

import styles from '../../../styles/cards/poutine.module.scss';

const propTypes = {
    theme: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    theme: null,
    className: null,
};

// eslint-disable-next-line no-unused-vars
const CustomPoutineCard = ({ theme, className }) => (
    <div
        className={classNames([
            styles.container,
            styles[theme],
            {
                [className]: className !== null,
            },
        ])}
    >
        <div className={styles.inner}>
            <div className={styles.top}>
                <img className={styles.poutine} src={poutine} alt="Poutine" />
                <div className={styles.left}>
                    <div className={styles.stat}>
                        44
                        <em>%</em>
                        <span>
                            Grand
                            <br />
                            Montréal
                        </span>
                    </div>
                </div>
                <div className={styles.right}>
                    <div className={styles.stat}>
                        56
                        <em>%</em>
                        <span>
                            Reste du
                            <br />
                            québec
                        </span>
                    </div>
                </div>
            </div>
            <div className={styles.bottom}>
                <FormattedMessage
                    defaultMessage="Urbania users ratio"
                    description="Placeholder poutine"
                />
            </div>
        </div>
    </div>
);
CustomPoutineCard.propTypes = propTypes;
CustomPoutineCard.defaultProps = defaultProps;

export default CustomPoutineCard;
